import React, { useEffect, useState } from 'react';

import { TabBar, TextCard } from "../../components"
import { BusinessPageContainer } from './styled';
import { BUSINESS } from "../../const"

function BusinessPage() {
    const tabNames = BUSINESS.map((business, idx) => business.field);

    const [tab, setTab] = useState(tabNames[0]);
    const [field, setField] = useState(BUSINESS[0]);

    useEffect(() => {
        const newField = BUSINESS.find((field) => field.field === tab);
        setField(newField);
      }, [tab]);

    return (
        <BusinessPageContainer>
            
            <h1 className="header">사업분야</h1>

            <TabBar list={tabNames} current={tab} setCurrent={setTab}/>

            <div style={{ margin: "30px" }}>
                {field.list.map((item, idx) => {
                    return <TextCard business_kor={item.kor} business_eng={item.eng} inline={true} />
                })}
            </div>
            
        </BusinessPageContainer>
    );
}

export default BusinessPage;